import React, { useState, useEffect, useContext } from "react"
import Page from "../pages/page"
import { PageProvider } from "../context/pageContext"
import { SectionProvider } from "../context/sectionContext"
import { JourneyProvider } from "../context/journeyContext"
import { ConditionProvider } from "../context/conditionContext"
import { ErrorProvider } from "../context/errorContext"
import { RepeatableProvider } from "../context/repeatableContext"
import { JourneyContext } from "../context/journeyContext"
import * as lookup from "../../../static/lookup.json"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const JourneyOne = (props) => {
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [hsbcData, setHsbcData] = useState(null)
  const pages = journeyState.journeySteps.pages
  const [currentPageIndex, setCurrentPageIndex] = useState(0)
  const [showFirstSectionFields, setShowFirstSectionFields] = useState(false)
  useEffect(() => {
    if (props.channel) {
      setJourneyState(prev => {
        return ({
          ...prev,
          // channel: lookup["reverseChannelType"]?.[0]?.[props.channel.toUpperCase()] || "D"
          channel: lookup["reverseChannelType"]?.[0]?.[props.channel.toUpperCase()] || props.channel
        })
      })

    }
  }, [props.channel])

  let temp = journeyState.journeySteps
  const changeJourneySteps = (pageId, sectionId, componentGroup, componentFormControlKey, key, value) => {
    try {
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroup)
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === componentFormControlKey)
      console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "======>ImpTemp0")
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange][key] = value
    } catch (err) {
      console.log(err, "=====>ErrorInPage.js===Line-152")
    }
  }

  const updateRmDataOrHsbcData = ()=>{
     if (props.rmData || props.hsbcBankData || hsbcData) {
      let tempHsbcData = props.hsbcBankData || hsbcData
      console.log(props);
      let fillProposalPageId
      let firstPageId
      let firstSectionId
      if (journeyState.journeyIdFromStrapi === "pension4LifeJourney") {
        fillProposalPageId = "PagePension4lifeFillProposalForm"
        firstPageId = "PagePension4lifeCalculateAnnutiyInstallment"
        firstSectionId = "SectionPension4lifePersonalDetailsofPrimaryAnnuitment"
        changeJourneySteps(fillProposalPageId, "SectionPension4lifePrimaryAnnuitantPersonalDetail", "PDcurrentCountryofResidence", "PDcurrentCountryofResidence", "disabled", true)
        changeJourneySteps(fillProposalPageId, "SectionPension4lifePrimaryAnnuitantPersonalDetail", "PDCurrentState", "PDCurrentState", "lookupKey", "state_RM")
        changeJourneySteps(fillProposalPageId, "SectionPension4lifePrimaryAnnuitantPersonalDetail", "PDResidentialStatus", "PDResidentialStatus", "disabled", true)
        changeJourneySteps(fillProposalPageId, "SectionPension4lifePrimaryAnnuitantPersonalDetail", "PDCitizenship", "PDCitizenship", "disabled", true)
        changeJourneySteps(fillProposalPageId, "SectionPension4lifePrimaryAnnuitantPersonalDetail", "PDNationality", "PDNationality", "disabled", true)
        changeJourneySteps(fillProposalPageId, "SectionPension4lifePrimaryAnnuitantPersonalDetail", "PDTaxResidenceCountry", "PDTaxResidenceCountry", "disabled", true)
        changeJourneySteps(fillProposalPageId, "SectionPension4lifePrimaryAnnuitantPersonalDetail", "PDcountryOfBirth", "PDcountryOfBirth", "disabled", true)
      }
      else if (journeyState.journeyIdFromStrapi === "smartGuaranteedPensionJourney") {
        fillProposalPageId = "PagePension4lifeFillProposalForm"
        firstPageId = "PageSmartGuaranteedPensionCalculatePremium"
        firstSectionId = "SectionSmartGuaranteedPensionPersonalDetails"
        changeJourneySteps(fillProposalPageId, "SectionPension4lifePrimaryAnnuitantPersonalDetail", "PDcurrentCountryofResidence", "PDcurrentCountryofResidence", "disabled", true)
        changeJourneySteps(fillProposalPageId, "SectionPension4lifePrimaryAnnuitantPersonalDetail", "PDCurrentState", "PDCurrentState", "lookupKey", "state_RM")
        changeJourneySteps(fillProposalPageId, "SectionPension4lifePrimaryAnnuitantPersonalDetail", "PDResidentialStatus", "PDResidentialStatus", "disabled", true)
        changeJourneySteps(fillProposalPageId, "SectionPension4lifePrimaryAnnuitantPersonalDetail", "PDCitizenship", "PDCitizenship", "disabled", true)
        changeJourneySteps(fillProposalPageId, "SectionPension4lifePrimaryAnnuitantPersonalDetail", "PDNationality", "PDNationality", "disabled", true)
        changeJourneySteps(fillProposalPageId, "SectionPension4lifePrimaryAnnuitantPersonalDetail", "PDTaxResidenceCountry", "PDTaxResidenceCountry", "disabled", true)
        changeJourneySteps(fillProposalPageId, "SectionPension4lifePrimaryAnnuitantPersonalDetail", "PDcountryOfBirth", "PDcountryOfBirth", "disabled", true)
      }
      else {
        return
      }
      // changeJourneySteps(firstPageId, "CPPersonalDetailsSection", "contactNo", "contactCountryCode", "disabled", true)

      if(tempHsbcData?.editable && firstSectionId && firstPageId){
        const editable = tempHsbcData.editable;
        const editableName = editable?.firstName || editable?.middleName || editable?.lastName;
        changeJourneySteps(firstPageId, firstSectionId, "namePension4life", "namePension4life", "disabled", !editableName)
        const phoneNumberEditable = editable?.phone;
        changeJourneySteps(firstPageId, firstSectionId, "contactNoPension4life", "contactNoPension4life", "disabled", !phoneNumberEditable)
        const phoneCountryCodeEditable = editable?.phoneCountryCode;
        changeJourneySteps(firstPageId, firstSectionId, "contactNoPension4life", "CountryCodesPension4life", "disabled", !phoneCountryCodeEditable)
        const emailEditable = editable?.email;
        changeJourneySteps(firstPageId, firstSectionId, "emailPension4life", "emailPension4life", "disabled", !emailEditable)
        const titleEditable = editable?.title;
        changeJourneySteps(firstPageId, firstSectionId, "namePension4life", "laTitle", "disabled", !titleEditable)
        changeJourneySteps(firstPageId, firstSectionId, "namePension4life", "namePension4life", "class", 'col-lg-4 col-md-12 col-12')
      }

       // freezing pincode and country for hsbc customer id journey if pincode and country are valid and they are not present in editable object
     
       if (tempHsbcData?.currentCountry && !tempHsbcData?.editable?.country){
        changeJourneySteps(firstPageId, firstSectionId , "CountryOfCurrentPension4life", "CountryOfCurrentPension4life", "disabled", !tempHsbcData?.editable?.country)
        
        // pincode can only be frozen in country exists and is valid
        // alternatecase: pincode fields if freezed but since country is not valid, pincode will be undetiable in india's case
        if (tempHsbcData?.pincode && !tempHsbcData?.editable?.pincode){
          changeJourneySteps(firstPageId, firstSectionId , "PinCodePension4life", "PinCodePension4life", "disabled", !tempHsbcData?.editable?.pincode)
        }
      }

      changeJourneySteps(fillProposalPageId, "personalDetailsSection", "alternateMobileNo", "AlternateMobCountryCode", "disabled", true)

      changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentStatus", "disabled", true)
      changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialCountryOfBirth", "disabled", true)
      changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialCitizenship", "disabled", true)
      changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialNationality", "disabled", true)
      changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialTaxResidentialCountry", "disabled", true)

      changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRCountry", "disabled", true)
      changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRState", "lookupKey", "state_RM")

      console.log(temp, "======>ImpTemp")
      if(props.rmData){
        setJourneyState(prev => {
          return ({
            ...prev,
            channel: "A",
            rmLedJourney: "Y",
            agentDetails: {
              "rmLedJourneyInd": "01",
              "rmLedFNAInd": "N",
              "hsbcRMName": props.rmData?.LEVEL1_NAME,
              "hsbcRMMobileNo": props.rmData?.JV_RM_PHONE_NO,
              "rmLedAgentId": props.rmData?.LEVEL1_ID_SP,
              "hsbcRMEmailId": props.rmData?.MAIL_ID,
              "rmName": props.rmData?.LEVEL1_NAME,
              "rmContactNo": props.rmData?.JV_RM_PHONE_NO,
              "rmLedAgentBRCode": props.rmData?.BRANCHID,
              "rmLedAgentBRName": props.rmData?.BRANCH_LOCATION
            },
            journeySteps: temp
          })
        })
      }
    }
  }

  useEffect(() => {
   updateRmDataOrHsbcData()
  }, [props.rmData, hsbcData])

  useEffect(() => {
    if (props.hsbcBankData) {
      setHsbcData(props.hsbcBankData)
    }
  }, [props.hsbcBankData])

  return (
    <>
     <GoogleReCaptchaProvider reCaptchaKey={process.env.RECAPTCHA_SITE_KEY}>
      <PageProvider>
        <SectionProvider>
          <ConditionProvider>
            <ErrorProvider>
              <RepeatableProvider>
                <style>
                  {`
                      .input-group.date .input-group-addon{
                        background:none;
                      }
                
                      @media (max-width: 767px){

                        .form-group {
                          margin-bottom: 34px;
                        }
                        
                      }
                      .threetabs ul li:nth-child(2).active, .threetabs ul li:nth-child(3).active, .threetabs ul li:nth-child(4).active{
                        margin-left:-2px;
                      }
                      
                    .threetabs ul li:nth-child(2).active, .threetabs ul li:nth-child(3).active, .threetabs ul li:nth-child(4).active{
                      margin-left:-2px;
                    }
                    ::-ms-clear {
                      display: none;
                    }    
                    .d-none{
                      display: none;
                    }   
                    .br-0{
                      border-radius: 0px !important;
                    }
                  `}
                </style>

                {/* <!--Step design Start--> */}
                <div className="container">
                  <div className={`${props.channel} threetabs left-tab-listing-design`}>
                    {/* className="tabsthree active" */}
                    <ul>
                      {pages?.map((page, index, arr) => {
                        return (
                          <li
                            className={
                              index === 0
                                ? `${index <= currentPageIndex ? "tabsone active" : ""} ${index < currentPageIndex ? "br-0" : ""}`
                                : index === pages.length - 1
                                  ? `${index <= currentPageIndex ? "tabsthree active" : ""} ${index < currentPageIndex ? "br-0" : ""}`
                                  : `${index <= currentPageIndex ? "tabstwo active" : ""} ${index < currentPageIndex ? "br-0" : ""}`
                            }
                            key={page?.pageId}
                          >
                            <a>{page?.name}</a>
                            <span className={`${index < arr.length - 1 ? "fa fa-angle-right" : "d-none"}`}></span>
                          </li>
                        )
                      })}
                    </ul>
                  </div>
                </div>
                {/* <!--mobile-progress--> */}
                <div className="progress-mobile-bg-structure">
                  <div className="mobile-progressbar-design-new mobile-progress-structure-design">
                    <ul className="nav nav-tabs mobile-progressbar-design-new-nav">
                      {pages?.map((page, index) => {
                        return (
                          <li className={`${index <= currentPageIndex ? "active" : ""}`} key={page?.pageId}>
                            {" "}
                            <a>
                              <span className="fa fa-angle-right"></span>
                            </a>
                            <div className={`${index < pages.length - 1 ? "liner" : ""} ${index <= currentPageIndex ? "active" : ""}`}></div>
                          </li>
                        )
                      })}
                    </ul>
                  </div>
                  <div className="mobile-resume-structure">
                    <div className="app-quatation mt">
                      <div className="application-design-number">
                        Application Number: {journeyState.applicationNo}
                      </div>
                    </div>
                  </div>
                </div>
                {/* <!--mobile-progress-->  */}
                {/* <!--Step design End-->  */}

                <Page setHsbcData={setHsbcData} sections={pages?.[currentPageIndex]?.sections} pageId={pages?.[currentPageIndex]?.pageId} currentPageIndex={currentPageIndex} setCurrentPageIndex={setCurrentPageIndex} pages={pages} resumeJourneyData={props.resumeJourneyData} decryptData={props.decryptData} journeyId={props.journeyId} paymentData={props.paymentData} digilockerdata={props.digilockerdata} enachData={props.enachData} fnaData={props.fnaData} showFirstSectionFields={showFirstSectionFields} setShowFirstSectionFields={setShowFirstSectionFields} canaraPosData={props.canaraPosData} hsbcBankData={props.hsbcBankData} lienData={props.lienData} />
              </RepeatableProvider>
            </ErrorProvider>
          </ConditionProvider>
        </SectionProvider>
      </PageProvider>
     </GoogleReCaptchaProvider>
    </>
  )
}

export default JourneyOne
